(() => {
  const TEMPLATE_SELECTOR = ':is(.template-suffix-bark-belt-pdp, .template-suffix-guardian-pdp)';

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getHero() {
    return document.querySelector(`${TEMPLATE_SELECTOR} bark-belt-product`);
  }

  function findHeroSize(value) {
    const normalizedValue = normalize(value);
    return Array.from(document.querySelectorAll(`${TEMPLATE_SELECTOR} [data-bb-size-trigger][data-price-cents]`))
      .find((trigger) => normalize(trigger.dataset.optionValue) === normalizedValue);
  }

  function setSizingState(value) {
    const normalizedValue = normalize(value);
    document.querySelectorAll(`${TEMPLATE_SELECTOR} [data-bb-size-choice]`).forEach((choice) => {
      const selected = normalize(choice.dataset.bbSizeChoice) === normalizedValue;
      choice.classList.toggle('is-selected', selected);
      choice.setAttribute('aria-pressed', String(selected));
    });
  }

  function selectSize(value) {
    const hero = getHero();
    const optionTrigger = Array.from(document.querySelectorAll(`${TEMPLATE_SELECTOR} [data-bb-size-choice-trigger]`))
      .find((trigger) => normalize(trigger.dataset.optionValue) === normalize(value));

    if (hero && optionTrigger && typeof hero.selectProductOption === 'function') {
      const selected = hero.selectProductOption(optionTrigger.dataset.optionPosition, optionTrigger.dataset.optionValue);
      if (selected) setSizingState(value);
      return selected;
    }

    const trigger = findHeroSize(value);
    if (!hero || !trigger || trigger.dataset.available !== 'true') return false;

    hero.selectVariant(trigger.dataset.variantId);
    setSizingState(value);
    return true;
  }

  function revealProductForm() {
    const target = document.querySelector(`${TEMPLATE_SELECTOR} .bb-hero__size-options`)
      || document.querySelector(`${TEMPLATE_SELECTOR} .bb-hero__purchase`);

    if (!target) return;
    if (window.theme?.scrollToRevealElement) {
      window.theme.scrollToRevealElement(target);
    } else {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function initializeSizing(sectionRoot = document) {
    sectionRoot.querySelectorAll('[data-bb-size-choice]').forEach((choice) => {
      if (choice.dataset.bbBound === 'true') return;
      choice.dataset.bbBound = 'true';
      choice.addEventListener('click', () => selectSize(choice.dataset.bbSizeChoice));
    });

    sectionRoot.querySelectorAll('[data-bb-size-cta]').forEach((button) => {
      if (button.dataset.bbBound === 'true') return;
      button.dataset.bbBound = 'true';
      button.addEventListener('click', () => {
        const selectedChoice = document.querySelector(`${TEMPLATE_SELECTOR} [data-bb-size-choice].is-selected`);
        if (selectedChoice) selectSize(selectedChoice.dataset.bbSizeChoice);
        revealProductForm();
      });
    });

    const selectedTrigger = document.querySelector(`${TEMPLATE_SELECTOR} [data-bb-size-choice-trigger].is-selected`)
      || document.querySelector(`${TEMPLATE_SELECTOR} [data-bb-size-trigger][data-price-cents].is-selected`);
    if (selectedTrigger) setSizingState(selectedTrigger.dataset.optionValue);
  }

  document.addEventListener('DOMContentLoaded', () => initializeSizing());
  document.addEventListener('shopify:section:load', (event) => initializeSizing(event.target));
  document.addEventListener('bb:variant:change', (event) => {
    const trigger = document.querySelector(`${TEMPLATE_SELECTOR} [data-bb-size-choice-trigger].is-selected`)
      || document.querySelector(
      `${TEMPLATE_SELECTOR} [data-bb-size-trigger][data-price-cents][data-variant-id="${event.detail.variantId}"]`
    );
    if (trigger) setSizingState(trigger.dataset.optionValue);
  });
})();
